import './Footer.css';

function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer style={{
            width: '100%',
            backgroundColor: 'var(--bg-color)',
            padding: '12px',
        }}>
            <div className="container-fluid">
                <div className="center" style={{ fontFamily: 'monospace' }}>
                    Character Forge
                </div>

                <div className="center">
                    © {year} D&amp;D Character Creator
                </div>
            </div>
        </footer>
    );
}

export default Footer;
